import { createIntegrationConnectionConfigurationClassMixin } from '../../../connection/configuration/IntegrationConnectionConfigurationMixin';

export interface MindbodyLocationConfigurationValid {
    type: 'VALID';
    siteId: number;
}

export interface MindbodyLocationConfigurationMissing {
    type: 'MISSING_SITE_ID';
}

export type MindbodyLocationConfigurationUnion =
    | MindbodyLocationConfigurationMissing
    | MindbodyLocationConfigurationValid;

export class MindbodyLocationConfiguration extends createIntegrationConnectionConfigurationClassMixin<
    MindbodyLocationConfigurationUnion,
    'MINDBODY_LOCATION'
>('MINDBODY_LOCATION') {}
